import { createContext } from "react";

const GoogleMapsContext = createContext<{ maps: boolean }>({
  maps: false,
});

export default GoogleMapsContext;
